/**
 * POR NEGOCIO: cuanto entro y salio de la cuenta compartida para cada negocio en el mes (T5; Ares #28909).
 *
 * Audiencia: el admin en Auditoria > Conciliacion banco > "Por negocio", en el computador; tambien a 375 px.
 * Aparece junto a "Atribuir movimientos" (cuenta compartida y rol admin). Dice NETO, no saldo: el extracto no trae
 * saldo y un saldo pide el saldo inicial de la cuenta. Lo sin atribuir se muestra aparte, sin repartir.
 *
 * @module presentation/components/conciliacion/NetosPorNegocio
 */

import { AuditoriaApiClient } from '../../../infrastructure/api/AuditoriaApiClient.js';
import { netosDelMes, totalDelMes, mesesDe } from '../../../application/conciliacion/netosPorNegocio.js';
import { esc, plata, ponerCss } from './BandejaPropuestasBanco.js';

const MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
const nombreMes = (m) => { const x = /^(\d{4})-(\d{2})$/.exec(String(m || '')); return x ? `${MESES[Number(x[2]) - 1]} ${x[1]}` : String(m || ''); };
const firmado = (n) => (n < 0 ? '- ' : '') + plata(Math.abs(n));

/**
 * @param {object} o
 * @param {string} o.businessId
 * @param {() => {destino:string, nombre:string}[]} o.destinos  los destinos de la cuenta (los trae la atribucion)
 * @param {object} [o.cliente]  AuditoriaApiClient (se cambia en las pruebas)
 */
export function crearNetosPorNegocio({ businessId, destinos, cliente = AuditoriaApiClient } = {}) {
  const st = { items: null, mes: '', cargando: false, error: null };
  let raiz = null;

  async function cargar() {
    st.cargando = true; st.error = null; pintar();
    const res = await cliente.listBankMovements(businessId);
    st.cargando = false;
    if (!res.ok) { st.error = res.error || 'No se pudo leer el extracto.'; pintar(); return; }
    st.items = res.items;
    const meses = mesesDe(st.items);
    if (!meses.includes(st.mes)) st.mes = meses[0] || '';
    pintar();
  }

  function pintar() {
    if (!raiz) return;
    const meses = st.items ? mesesDe(st.items) : [];
    const filas = st.items ? netosDelMes(st.items, st.mes, typeof destinos === 'function' ? destinos() : []) : [];
    const t = totalDelMes(filas);
    raiz.innerHTML = `
      <div class="bp-barra">
        ${st.items ? `<label>Mes<select data-np-mes>${meses.map((m) => `<option value="${esc(m)}" ${m === st.mes ? 'selected' : ''}>${esc(nombreMes(m))}</option>`).join('')}</select></label>` : ''}
        <button type="button" class="btn btn-primary btn-sm" data-np-cargar ${st.cargando ? 'disabled' : ''}>${st.cargando ? 'Cargando…' : (st.items ? 'Actualizar' : 'Ver por negocio')}</button>
      </div>
      ${st.error ? `<div class="bp-error">${esc(st.error)}</div>` : ''}
      ${st.items ? `
        <div class="bp-mes">${esc(nombreMes(st.mes) || 'Sin movimientos')}: cuanto entro y salio de la cuenta para cada negocio.
          <div class="bp-cuentas"><span>Es el <b>neto</b> del mes, no el saldo: el extracto no trae saldo.</span></div>
        </div>
        ${filas.map((f) => `<article class="bp-dia" data-np-destino="${esc(f.destino)}">
          <div class="bp-cab" style="cursor:default">
            <span class="bp-fecha">${esc(f.nombre)}</span>
            <span style="font-size:0.875rem;color:#8b949e">${f.movimientos} mov.</span>
            <span style="font-weight:700;color:${f.neto < 0 ? '#f85149' : '#3fb950'}">${firmado(f.neto)}</span>
          </div>
          <div class="bp-fila"><span>Entro</span><span>${plata(f.entradas)}</span></div>
          <div class="bp-fila"><span>Salio</span><span>${plata(f.salidas)}</span></div>
          ${f.destino === 'sin-atribuir' && f.movimientos > 0 ? '<p class="bp-texto" style="color:#d29922">Sin atribuir todavia: atribuyelos en "Atribuir movimientos" para que cuenten en su negocio.</p>' : ''}
        </article>`).join('')}
        <article class="bp-dia" data-np-total>
          <div class="bp-cab" style="cursor:default"><span class="bp-fecha">Toda la cuenta</span>
            <span style="font-size:0.875rem;color:#8b949e">${t.movimientos} mov.</span>
            <span style="font-weight:700">${firmado(t.neto)}</span></div>
        </article>` : ''}`;
    raiz.querySelector('[data-np-cargar]')?.addEventListener('click', cargar);
    raiz.querySelector('[data-np-mes]')?.addEventListener('change', (e) => { st.mes = e.target.value; pintar(); });
  }

  return {
    estado: st,
    cargar,
    montar(el) {
      if (!el) return;
      raiz = el;
      raiz.classList.add('ban-prop');
      ponerCss(el.ownerDocument);
      pintar();
    }
  };
}
